export interface ConflictedDoc {
  id: string;
  winnerRev: string;
  winnerDoc: PouchDB.Core.ExistingDocument<PouchDB.Core.AllDocsMeta>;
  conflictRevs: string[];
  conflictDocs: Array<PouchDB.Core.Document<{}> & PouchDB.Core.GetMeta>;
}

export async function loadAllConflicts(db: PouchDB.Database): Promise<ConflictedDoc[]> {
  const result = await db.allDocs<PouchDB.Core.AllDocsMeta>({ conflicts: true, include_docs: true });
  const found: ConflictedDoc[] = [];
  for (const row of result.rows) {
    if (row.doc == null) continue;
    const conflictRevs = row.doc._conflicts;
    if (!conflictRevs || conflictRevs.length === 0) continue;
    const conflictDocs = await Promise.all(
      conflictRevs.map(rev => db.get(row.id, { rev }))
    );
    found.push({
      id: row.id,
      winnerRev: row.doc._rev,
      winnerDoc: row.doc,
      conflictRevs,
      conflictDocs,
    });
  }
  return found;
}
